import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 35rem;
  height:80vh;
  flex-direction: column;
  overflow-y: scroll;
  &::-webkit-scrollbar{
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb{
    background-color: rgb(0, 0, 0,0.2);
  }
` 